<template>
    <div class="min-h-screen bg-[#f2f2f7]">

        <!-- HEADER -->
        <div class="flex items-center gap-3 px-4 pt-5 pb-3">
            <button
                class="w-8 h-8 flex items-center justify-center rounded-full bg-white shadow-sm active:bg-gray-50 shrink-0"
                @click="$router.back()"
            >
                <svg class="w-4 h-4 text-gray-800" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                    <polyline points="15 18 9 12 15 6" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
            <span class="text-[16px] font-extrabold text-gray-900">Annuler l'intervention</span>
        </div>

        <!-- CONTENU -->
        <div class="px-4 pb-10 flex flex-col gap-2">

            <p class="text-[13px] text-gray-400 font-medium px-1 pb-2">
                Sélectionnez un motif
            </p>

            <!-- Motifs -->
            <div class="max-h-[60vh] overflow-y-auto flex flex-col gap-2">
                <button
                    v-for="motif in motifs"
                    :key="motif"
                    class="w-full flex items-center gap-3 px-4 py-[14px] rounded-[14px] border-[1.5px] bg-white text-left active:bg-gray-50"
                    :class="selected === motif
                        ? 'border-red-400 bg-red-50'
                        : 'border-gray-200'"
                    @click="selected = motif; custom = ''"
                >
                    <span
                        class="w-5 h-5 rounded-full border-2 flex items-center justify-center shrink-0"
                        :class="selected === motif ? 'border-red-500 bg-red-500' : 'border-gray-300'"
                    >
                        <svg v-if="selected === motif" class="w-3 h-3 text-white" viewBox="0 0 12 12" fill="none">
                            <path d="M2 6l3 3 5-5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </span>
                    <span
                        class="text-[14px] font-semibold"
                        :class="selected === motif ? 'text-red-700' : 'text-gray-700'"
                    >
                        {{ motif }}
                    </span>
                </button>
            </div>

            <!-- Autre motif -->
            <p class="text-[11px] font-bold text-gray-400 uppercase tracking-[.08em] px-1 mt-3">
                Autre motif
            </p>
            <textarea
                v-model="custom"
                class="w-full px-4 py-3.5 rounded-[14px] border-[1.5px] border-gray-200 bg-white text-[14px] text-gray-900 placeholder-gray-400 outline-none resize-none focus:border-red-300"
                :class="custom.trim() ? 'border-red-300' : 'border-gray-200'"
                rows="3"
                placeholder="Précisez si besoin…"
                @input="selected = ''"
            />

            <!-- Bouton confirmer -->
            <button
                class="w-full flex items-center justify-center py-4 rounded-[15px] text-[16px] font-extrabold mt-2 disabled:opacity-35"
                :class="motifFinal.trim() ? 'bg-red-500 text-white active:bg-red-600' : 'bg-red-500 text-white'"
                :disabled="!motifFinal.trim() || cancelling"
                @click="confirmer"
            >
                <span v-if="cancelling" class="w-5 h-5 border-2 border-white/40 border-t-white rounded-full animate-spin mr-2"></span>
                {{ cancelling ? 'Annulation…' : 'Confirmer l\'annulation' }}
            </button>

        </div>
    </div>
</template>

<script>
export default {
    name: 'InterventionAnnulation',

    data() {
        return {
            selected: '',
            custom: '',
            cancelling: false,
            motifs: [
                'Client absent',
                'Client injoignable',
                'Accès impossible',
                'Client a refusé',
                'Pièce manquante',
                'Mauvaise pièce commandée',
                'Équipement inaccessible',
                'Installation non conforme',
                'Risque électrique détecté',
                'Fuite de gaz détectée',
                'Sécurité non réunie',
                'Erreur de planning',
                'Annulée par le client',
                'Contrat expiré',
            ],
        };
    },

    computed: {
        interventionId() { return this.$route.params.id; },
        chantierId()      { return this.$route.params.chantierId; },
        motifFinal()      { return this.custom.trim() || this.selected; },
    },

    methods: {
        async confirmer() {
            if (!this.motifFinal.trim()) return;
            this.cancelling = true;
            try {
                await this.$request.post(`/interventions/annuler-creneau`, {
                    motif: this.motifFinal,
                    planning_event_id: this.$route.params.planningId
                });
                this.clearCache();
                this.$router.replace(`/`);
            } catch (e) {
                alert(e?.message || 'Impossible d\'annuler');
            } finally {
                this.cancelling = false;
            }
        },

        clearCache() {
            const id = this.interventionId;
            [
                `intervention-${id}`,
                `travaux-${id}`,
                `intervention-form-${id}`,
                `intervention:${id}:pv_reception`,
                `intervention:${id}:attestation_entretien`,
                `intervention:${id}:contrat_entretien`,
                `cerfa_draft_${id}`,
            ].forEach(k => { try { localStorage.removeItem(k); } catch {} });
        },
    },
};
</script>